import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { OfbizField, OfbizForm, OfbizFormsService } from '@urbannex/ofbiz-forms';
// import { CkeditorLoaderService } from '../../../ckeditor-loader.service';

@Component({
  selector: 'ubs-edit-article-data',
  templateUrl: './edit-article-data.component.html',
  styleUrls: ['./edit-article-data.component.scss']
})
export class EditArticleDataComponent implements OnInit {
  @Input() articleData:any;
  @Input() formGroupName: string;
  @Input() ofbizForm:OfbizForm;
  @Input() fields:OfbizField[];
  initialstate = "view";
  form: FormGroup;
  hasChanged:boolean = false;

  @Output() articleSubmit = new EventEmitter<string>();
  
  constructor(private rootFormGroup: FormGroupDirective) { }

  ngOnInit(): void {
    this.form = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
    console.log({articleControls:this.form.controls});
    // this.ckEditorLoaded = this.ckeditorLoaderService.loadCkEditor();
  }

  submit(){
    this.articleSubmit.emit(this.form.value); 
  }
  onChangeEvent(e){
    console.log("Has changed ....");
    this.hasChanged = true;
  }
  reset(){
    this.form.get("articleData").setValue(this.articleData);
  }

}
